<template>
    <div class="share-button">
        <button
            v-if="isNativeShare || isRedirect"
            class="share-button__button button"
            @click="buttonClick"
        >
            <zoe-atom-text
                class="share-button__label"
                :item="label"
            />
        </button>

        <a
            v-if="isSocialShare"
            id="facebook-messenger"
            ref="regularShareButton"
            class="button share-button__social share-button__social--facebook"
            target="_blank"
            :href="`fb-messenger://share?link=${url}`"
        >
            <svg viewBox="0 0 90 90">
                <path
                    d="M90,43.841c0,24.213-19.779,43.841-44.182,43.841c-7.747,0-15.025-1.98-21.357-5.455L0,90l7.975-23.522   c-4.023-6.606-6.34-14.354-6.34-22.637C1.635,19.628,21.416,0,45.818,0C70.223,0,90,19.628,90,43.841z M45.818,6.982   c-20.484,0-37.146,16.535-37.146,36.859c0,8.065,2.629,15.534,7.076,21.61L11.107,79.14l14.275-4.537   c5.865,3.851,12.891,6.097,20.437,6.097c20.481,0,37.146-16.533,37.146-36.857S66.301,6.982,45.818,6.982z M68.129,53.938   c-0.273-0.447-0.994-0.717-2.076-1.254c-1.084-0.537-6.41-3.138-7.4-3.495c-0.993-0.358-1.717-0.538-2.438,0.537   c-0.721,1.076-2.797,3.495-3.43,4.212c-0.632,0.719-1.263,0.809-2.347,0.271c-1.082-0.537-4.571-1.673-8.708-5.333   c-3.219-2.848-5.393-6.364-6.025-7.441c-0.631-1.075-0.066-1.656,0.475-2.191c0.488-0.482,1.084-1.255,1.625-1.882   c0.543-0.628,0.723-1.075,1.082-1.793c0.363-0.717,0.182-1.344-0.09-1.883c-0.27-0.537-2.438-5.825-3.34-7.977   c-0.902-2.15-1.803-1.792-2.436-1.792c-0.631,0-1.354-0.09-2.076-0.09c-0.722,0-1.896,0.269-2.889,1.344   c-0.992,1.076-3.789,3.676-3.789,8.963c0,5.288,3.879,10.397,4.422,11.113c0.541,0.716,7.49,11.92,18.5,16.223   C58.2,65.771,58.2,64.336,60.186,64.156c1.984-0.179,6.406-2.599,7.312-5.107C68.398,56.537,68.398,54.386,68.129,53.938z"
                />
            </svg>
        </a>

        <a
            v-if="isSocialShare"
            id="whatsapp"
            ref="regularShareButton"
            class="button share-button__social share-button__social--whatsapp"
            target="_blank"
            :href="`whatsapp://send?text=${url}`"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24.625"
            >
                <path
                    d="M12,0A11.77412,11.77412,0,0,0,0,11.5,11.21528,11.21528,0,0,0,4,20v4.625l4.4375-2.21875A12.2858,12.2858,0,0,0,12,23,11.77412,11.77412,0,0,0,24,11.5,11.77412,11.77412,0,0,0,12,0Zm0,2a9.74494,9.74494,0,0,1,10,9.5A9.74494,9.74494,0,0,1,12,21a10.46942,10.46942,0,0,1-3.40625-.59375l-.40625-.125L6,21.375v-2.25l-.375-.3125A9.29307,9.29307,0,0,1,2,11.5,9.74494,9.74494,0,0,1,12,2ZM10.875,8.34375l-6.03125,6.375,5.40625-3,2.875,3.09375,5.96875-6.46875L13.8125,11.3125Z"
                />
            </svg>
        </a>
    </div>
</template>

<script>
import ZoeAtomText from '../../atoms/text/v1.0.0/zoe-atom-text.vue';

export default {
    components: { ZoeAtomText },
    props: {
        shareType: {
            type: String,
            required: false,
            default: 'share',
        },

        label: {
            type: String,
            required: true,
        },

        url: {
            type: String,
            required: true,
        },

        shareText: {
            type: String,
            required: true,
        },

        shareTarget: {
            type: String,
            required: false,
            default: '_self',
        },
    },

    computed: {
        supportsNativeButton() {
            return !!navigator.share;
        },

        isPreview() {
            return this.$store.state.page.isPreview;
        },

        isNativeShare() {
            return this.shareType === 'share' && (this.supportsNativeButton || this.isPreview);
        },

        isSocialShare() {
            return this.shareType === 'share' && (!this.supportsNativeButton && !this.isPreview);
        },

        isRedirect() {
            return this.shareType === 'redirect';
        },
    },

    methods: {
        buttonClick() {
            if (this.shareType === 'share') {
                navigator.share({
                    text: this.shareText.replace(/<\/?[^>]+(>|$)/g, ''),
                    url: this.url,
                });
            } else {
                window.open(this.url, this.shareTarget);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'zoe-molecule-share-button';
</style>
